import * as React from "react";
const SvgFiRrMountain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mountain_svg__a)">
      <path
        fill="#062147"
        d="M23.625 19.29 14.476 1.493a2.798 2.798 0 0 0-4.957.01L.377 19.285a3.23 3.23 0 0 0 .091 3.192 3.21 3.21 0 0 0 2.77 1.567H20.76a3.21 3.21 0 0 0 2.77-1.567 3.22 3.22 0 0 0 .092-3.188zM11.292 2.428A.78.78 0 0 1 12 2a.78.78 0 0 1 .703.417l3.575 6.954-1.475 2.521-.947-1.563a1 1 0 0 0-.849-.482H13a1 1 0 0 0-.848.47l-1.625 2.7-2.579-4.084zm10.526 19.018a1.21 1.21 0 0 1-1.056.599H3.238c-.442 0-.827-.218-1.056-.599a1.23 1.23 0 0 1-.029-1.242l4.732-9.206 1.95 3.087c.362.573.982.915 1.66.915h.004a1.95 1.95 0 0 0 1.66-.922l.827-1.323.198.328c.35.576.948.87 1.633.913a1.88 1.88 0 0 0 1.62-.937l.924-1.578 4.49 8.735c.21.397.198.846-.034 1.231z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mountain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMountain;
